import { useState } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/daep8fjep053ijub1fm0";

export default function NewsletterForm() {
  const [state, setState] = useState<"idle" | "loading" | "success">("idle");
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("website_alt") || "").trim();
    if (honeypot) {
      setState("success");
      return;
    }

    const name = String(data.get("name") || "").trim();
    const email = String(data.get("email") || "").trim();
    if (!name || !email) {
      setError("请填写您的称呼与邮箱后再提交。");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("邮箱格式似乎不太对，请检查后再试。");
      return;
    }

    data.delete("website_alt");
    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      const v = String(value).trim();
      if (v) payload.append(key, v);
    });

    setState("loading");
    setError("");
    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      if (res.ok && parsed?.code === "OK") {
        setState("success");
        form.reset();
      } else {
        setError(
          typeof serverMsg === "string" && serverMsg
            ? serverMsg
            : "提交失败，请稍后再试。"
        );
        setState("idle");
      }
    } catch {
      setError("网络似乎开小差了，请稍后再试。");
      setState("idle");
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      data-readdy-form="true"
      className="mt-6 w-full rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7"
      noValidate
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end">
        <label className="flex flex-1 flex-col gap-1.5">
          <span className="text-xs font-medium text-foreground-600">您的称呼</span>
          <input
            type="text"
            name="name"
            maxLength={30}
            placeholder="怎么称呼您"
            className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
        <label className="flex flex-1 flex-col gap-1.5">
          <span className="text-xs font-medium text-foreground-600">常用邮箱</span>
          <input
            type="email"
            name="email"
            maxLength={80}
            placeholder="you@example.com"
            className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400"
          />
        </label>
        <label className="flex flex-1 flex-col gap-1.5">
          <span className="text-xs font-medium text-foreground-600">最关心哪类瓜</span>
          <select
            name="category"
            className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm outline-none focus:border-primary-400"
            defaultValue="全部话题"
          >
            <option>全部话题</option>
            <option>综艺热搜</option>
            <option>选秀热榜</option>
            <option>主播带货</option>
            <option>商界瓜田</option>
            <option>体育看台</option>
          </select>
        </label>
        <button
          type="submit"
          disabled={state === "loading"}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
        >
          {state === "loading" ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>提交中
            </>
          ) : (
            <>
              <i className="ri-mail-send-line"></i>订阅榜单
            </>
          )}
        </button>
      </div>

      {/* 反垃圾隐藏字段 */}
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {state === "success" && (
        <p className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-700">
          <i className="ri-checkbox-circle-fill"></i>
          订阅成功！每期榜单出炉后我们会第一时间发到您的邮箱。
        </p>
      )}
      {error && (
        <p className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-700">
          <i className="ri-error-warning-fill"></i>
          {error}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-400">
        每期约一篇榜单速递，不会频繁打扰。您可以随时退订。
      </p>
    </form>
  );
}